import { render } from "./Header.vue?vue&type=template&id=024bf555&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=024bf555&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src88616841/src/scan_material_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-024bf555"]])

export default __exports__